import { OAuthCallback } from '@/lib/auth/OAuthCallback';

/**
 * Admin OAuth callback handler.
 * Redirects to /admin on success, /admin/login on error.
 */
export function AuthCallback() {
  return (
    <OAuthCallback
      successRedirect="/admin"
      errorRedirect="/admin/login"
      callbackPath="/admin/callback"
      processingKeyPrefix="auth_processing_"
    />
  );
}
